<script>
import BarGraphStatisticAttestation from "./BarGraphStatisticAttestation.vue";

export default {
  name: "TabsStatisticAttestation",
  components: {BarGraphStatisticAttestation},

  props: {
    dateAttestations: {
      type: Array,
      required: true,
    },

    additionNameKey: {
      type: String,
      default: null,
    },

    sheetClass: {
      type: String,
      default: ""
    },
  },

  data() {
    return {
      tab: 0,
    };
  },

  methods: {
    keyName(date) {
      if (_.isNil(this.additionNameKey)) {
        return `${date}`
      } else {
        return `${this.additionNameKey}-${date}`
      }
    }
  },
}


</script>

<template>
  <div>
    <v-tabs
      v-model="tab"
      centered
      color="teal darken-3"
    >
      <v-tab
        v-for="dateAttestation in dateAttestations"
        :key="keyName(dateAttestation.date)"
      >
        {{dateAttestation.date}}
      </v-tab>
    </v-tabs>

    <keep-alive>
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="dateAttestation in dateAttestations"
          :key="keyName(dateAttestation.date)"
          v-once
        >
          <v-sheet :class="sheetClass">
            <slot :dateAttestation="dateAttestation"></slot>
          </v-sheet>
        </v-tab-item>
      </v-tabs-items>
    </keep-alive>

  </div>
</template>

<style scoped>

</style>